import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../TimeModal/TimeModalContext';

import Loading from '../Loading'

import styles from '../../styles/DynamicModal.module.css';

const AgreedAMsForCase = ({ idCase, onAppointmentSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [miniApplications, setMiniApplications] = React.useState([]);
    const [statusOfPriorityLines, setStatusOfPriorityLines] = React.useState('');
    const [mailingSuccess, setMailingSuccess] = React.useState(false);
    const [applications, setApplications] = React.useState([]);
    const [statusOfAdditionalLines, setStatusOfAdditionalLines] = React.useState('');
    const [loadingAdditionalLines, setLoadingAdditionalLines] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);
    const [status, setStatus] = React.useState('');

    React.useEffect(() => {
        axios.get(`/api/mini-applications-for-case?caseId=${idCase}`)
        .then((response) => {
            if (response.data.applications.length == 0) {
                setMiniApplications([]);
                setStatusOfPriorityLines('Письма отправлены корректно, на данный момент ни один арбитражный управляющий не претендует на ведение');
            } else {
                setStatusOfPriorityLines('');
                setMiniApplications(response.data.applications);
                setMailingSuccess(response.data.mailing_success);
            }
        })
        .catch((error) => {
            console.error(error);
            setStatus(`Произошла неизвестная ошибка. Попробуйте повторить попытку позднее`);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
        });
    }, [reload]);

    const showAllApplicationsForCase = () => {
        setLoadingAdditionalLines(true);
        axios.get(`/api/all-applications-for-case?caseId=${idCase}`)
        .then((response) => {
            if (response.data.applications.length == 0) {
                setApplications([]);
                setStatus('Произошла неизвестная ошибка. Попробуйте повторить попытку позднее');
            } else {
                setStatusOfAdditionalLines('');
                setApplications(response.data.applications);
            }
        })
        .catch((error) => {
            console.error(error);
            setStatus(`Произошла неизвестная ошибка. Попробуйте повторить попытку позднее`);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
            setLoadingAdditionalLines(false);
        });
    };

    const attachAMForCase = (caseId, email) => {
        setLoading(true);
        axios.put('/api/attach-am-for-case', {
            caseId: caseId,
            email: email
        })
        .then(() => {
            openTimeModal('Арбитражный управляющий успешно прикреплен к карточке', 'success');
            onAppointmentSuccess();
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`Не удалось прикрепить арбитражного управляющего к карточке. Попробуйте повторить позднее`, 'error');
        })
        .finally(() => {
            setLoading(false);
        });
    };

    const tryAgainSendOffers = (caseId) => {
        setLoading(true);
        axios.post('/api/try-again-send-offers', {
            caseId: caseId
        })
        .then(response => {
            setReload(true);
            openTimeModal(response?.data.message || response.message, 'success');
        })
        .catch(error => {
            openTimeModal(error.response?.data.message || error.message, 'error');
        })
        .finally(() => {
            setLoading(false);
        });
    };
    
    const tryAgainSendOffer = (caseId, email) => {
        setLoading(true);
        axios.post('/api/try-again-send-offer', {
            caseId: caseId,
            email: email
        })
        .then(response => {
            setReload(true);
            openTimeModal(response?.data.message || response.message, 'success');
        })
        .catch(error => {
            openTimeModal(error.response?.data.message || error.message, 'error');
        })
        .finally(() => {
            setLoading(false);
        });
    };

    const [showAll, setShowAll] = React.useState(false);

    const visibleApplications = showAll ? miniApplications : miniApplications.slice(0, 7);

    return (
        <>
            {loading ? (
                <Loading />
            ) : (
                <>
                    {!status &&
                        <>
                            <a>Статус опроса:</a>
                            {statusOfPriorityLines ? 
                                <a style={{fontSize: '14px', color: 'rgb(59 59 59)', margin: '5px 0'}}>{statusOfPriorityLines}</a>
                            :
                            !mailingSuccess && 
                                <div className={styles.panelSendOffersAgain}>
                                    <a>Некоторым арбитражным управляющим не удалось получить письмо с предложением дела.</a>
                                    <a onClick={() => {tryAgainSendOffers(idCase)}} className={styles.aWithLink}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="redo"><path fill="currentColor" d="M21,11a1,1,0,0,0-1,1,8.05,8.05,0,1,1-2.22-5.5h-2.4a1,1,0,0,0,0,2h4.53a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4.77A10,10,0,1,0,22,12,1,1,0,0,0,21,11Z"></path></svg>
                                        Доотправить письма
                                    </a>
                                </div>  
                            }
                            <>
                            {visibleApplications.map((application) => (
                                <div className={styles.wideMailingLine} key={application.id} style={application.user?.approval=='Отключен' ? {boxShadow: '0 0 0 1px red', backgroundColor: 'rgb(255, 222, 222)'} : {}}>
                                    <span className={styles.amInfoAction}>
                                        <span className={styles.amInfo}>
                                            {application.user?.approval=='Активен' ?
                                                <>
                                                    <a>{application.user?.lastname} {application.user?.firstname} {application.user?.surname}</a>
                                                </>
                                            : application.user?.approval=='Отключен' ?
                                                <a>Учетная запись арбитражного управляющего деактивирована.</a>
                                            : application.user?.approval=='На рассмотрении' ?
                                                <a>Арбитражный управляющий проходит регистрацию и ждёт одобрения учётной записи.</a>
                                            :
                                                <a>Арбитражный управляющий не зарегистрирован в системе.</a>
                                            }
                                            <a href={`mailto:${application.email}`} className={styles.aWithLink}>{application.email}</a>
                                            {application.user && <a>{application.user?.balance + ' ₽'}</a>}
                                            {application.file_id && <a className={`${styles.actionBtn} ${styles.aWithLink}`} onClick={() => window.open(`/file/${application.file_id}`, '_blank')}><img src='/img/icons/eye.svg' alt='Просмотреть' title='Просмотреть' />Просмотреть согласие</a> }
                                        </span>
                                        <span className={styles.amBtn}>
                                            {application.mailing_status=='Письмо не отправлено' ? 
                                                <button type='button' className='button black' onClick={() => {tryAgainSendOffer(application.case_id, application.email)}}>Отправить письмо</button>
                                            : application.status == 'Претендует' ? 
                                                <button type='button' className='button black' onClick={() => {attachAMForCase(application.case_id, application.email)}}>Выбрать</button>
                                            : application.user ?
                                                <button type='button' className='button gray' onClick={() => {attachAMForCase(application.case_id, application.email)}}>Выбрать</button>
                                            : <></>
                                            }
                                        </span>
                                    </span>
                                    {application.mailing_status=='Письмо не отправлено' ? (
                                        <div className={`${styles.applicationStatus} ${styles.red}`}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="exclamation-octagon"><path fill="currentColor" d="M12,7a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V8A1,1,0,0,0,12,7Zm0,8a1,1,0,1,0,1,1A1,1,0,0,0,12,15Zm9.71-7.44L16.44,2.29A1.05,1.05,0,0,0,15.73,2H8.27a1.05,1.05,0,0,0-.71.29L2.29,7.56A1.05,1.05,0,0,0,2,8.27v7.46a1.05,1.05,0,0,0,.29.71l5.27,5.27a1.05,1.05,0,0,0,.71.29h7.46a1.05,1.05,0,0,0,.71-.29l5.27-5.27a1.05,1.05,0,0,0,.29-.71V8.27A1.05,1.05,0,0,0,21.71,7.56ZM20,15.31,15.31,20H8.69L4,15.31V8.69L8.69,4h6.62L20,8.69Z"></path></svg>
                                            Не удалось отправить письмо при рассылке
                                        </div>
                                    ) : application.status == 'Претендует' ? 
                                        <a className={styles.applicationStatus}>
                                            <svg style={{height: '20px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="check-circle"><path fill="currentColor" d="M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l5-5a1,1,0,0,0,0-1.42A1,1,0,0,0,14.72,8.79ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"></path></svg>
                                            {application.status}
                                        </a>
                                    : application.status == 'Ранее откреплен' && 
                                        <a className={styles.applicationStatus}>
                                            <svg id="clock" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M15.09814,12.63379,13,11.42285V7a1,1,0,0,0-2,0v5a.99985.99985,0,0,0,.5.86621l2.59814,1.5a1.00016,1.00016,0,1,0,1-1.73242ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"></path></svg>
                                            {application.status}
                                        </a>
                                    }
                                </div>
                            ))}
                            {miniApplications.length > 7 && !showAll && (
                                <div style={{ marginTop: '10px' }}>
                                    <button className='miniButton' style={{fontSize: '15px', fontWeight: '600'}} onClick={() => setShowAll(true)}>Показать все</button>
                                </div>
                            )}
                            </>
                            <a style={{borderTop: '1px solid #e5e5e5', margin: '10px 0 15px 0'}}></a>
                            {loadingAdditionalLines ? <Loading />
                            :
                            (
                            <>
                                {applications.length == 0 ?
                                    <button type='button' className='miniButton' onClick={() => showAllApplicationsForCase()}>Просмотреть куда направлены письма</button>
                                :
                                    <button type='button' className='miniButton' style={{position: 'sticky', top: '5px'}} onClick={() => setApplications([])}>Скрыть все записи рассылки</button>
                                }

                                {applications && applications.length > 0 &&
                                    <>
                                        <a style={{marginTop: '15px'}}>Все записи рассылки:</a>
                                        {applications.map((application) => (
                                            <div className={styles.wideMailingLine} key={application.id} style={application.user?.approval=='Отключен' ? {boxShadow: '0 0 0 1px red', backgroundColor: 'rgb(255, 222, 222)'} : {}}>
                                                <span className={styles.amInfoAction}>
                                                    <span className={styles.amInfo}>
                                                        {application.user?.approval=='Активен' ?
                                                            <>
                                                                <a>{application.user?.lastname} {application.user?.firstname} {application.user?.surname}</a>
                                                            </>
                                                        : application.user?.approval=='Отключен' ?
                                                            <a>Учетная запись арбитражного управляющего деактивирована.</a>
                                                        : application.user?.approval=='На рассмотрении' ?
                                                            <a>Арбитражный управляющий проходит регистрацию и ждёт одобрения учётной записи.</a>
                                                        :
                                                            <a>Арбитражный управляющий не зарегистрирован в системе.</a>
                                                        }
                                                        <a href={`mailto:${application.email}`} className={styles.aWithLink}>{application.email}</a>
                                                        {application.user && <a>{application.user?.balance + ' ₽'}</a>}
                                                        {application.file_id && <a className={`${styles.actionBtn} ${styles.aWithLink}`} onClick={() => window.open(`/file/${application.file_id}`, '_blank')}><img src='/img/icons/eye.svg' alt='Просмотреть' title='Просмотреть' />Просмотреть согласие</a> }
                                                    </span>
                                                    <span className={styles.amBtn}>
                                                        {application.mailing_status=='Письмо не отправлено' ? 
                                                            <button type='button' className='button black' onClick={() => {tryAgainSendOffer(application.case_id, application.email)}}>Отправить письмо</button>
                                                        : application.status == 'Претендует' ? 
                                                            <button type='button' className='button black' onClick={() => {attachAMForCase(application.case_id, application.email)}}>Выбрать</button>
                                                        : application.user ?
                                                            <button type='button' className='button gray' onClick={() => {attachAMForCase(application.case_id, application.email)}}>Выбрать</button>
                                                        : <></>
                                                        }
                                                    </span>
                                                </span>
                                                {application.mailing_status=='Письмо не отправлено' ? (
                                                    <div className={`${styles.applicationStatus} ${styles.red}`}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="exclamation-octagon"><path fill="currentColor" d="M12,7a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V8A1,1,0,0,0,12,7Zm0,8a1,1,0,1,0,1,1A1,1,0,0,0,12,15Zm9.71-7.44L16.44,2.29A1.05,1.05,0,0,0,15.73,2H8.27a1.05,1.05,0,0,0-.71.29L2.29,7.56A1.05,1.05,0,0,0,2,8.27v7.46a1.05,1.05,0,0,0,.29.71l5.27,5.27a1.05,1.05,0,0,0,.71.29h7.46a1.05,1.05,0,0,0,.71-.29l5.27-5.27a1.05,1.05,0,0,0,.29-.71V8.27A1.05,1.05,0,0,0,21.71,7.56ZM20,15.31,15.31,20H8.69L4,15.31V8.69L8.69,4h6.62L20,8.69Z"></path></svg>
                                                        Не удалось отправить письмо при рассылке
                                                    </div>
                                                ) : application.status == 'Претендует' ? 
                                                    <a className={styles.applicationStatus}>
                                                        <svg style={{height: '20px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="check-circle"><path fill="currentColor" d="M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l5-5a1,1,0,0,0,0-1.42A1,1,0,0,0,14.72,8.79ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"></path></svg>
                                                        {application.status}
                                                    </a>
                                                : application.status == 'Ранее откреплен' && 
                                                    <a className={styles.applicationStatus}>
                                                        <svg id="clock" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M15.09814,12.63379,13,11.42285V7a1,1,0,0,0-2,0v5a.99985.99985,0,0,0,.5.86621l2.59814,1.5a1.00016,1.00016,0,1,0,1-1.73242ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"></path></svg>
                                                        {application.status}
                                                    </a>
                                                }
                                            </div>
                                        ))}
                                    </>
                                }
                            </>
                            )}
                        </>
                    }
                </>
            )}
            {status && <a className={styles.statusPanel}><img src='/img/icons/info-circle.svg' alt='Статус' />{status}</a>}
        </>
    );
};

export default AgreedAMsForCase;
